import React from 'react';
import { DollarSignIcon, TrendingUpIcon, ClockIcon, CarIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import { Button } from '../components/Button';
import { DriverToggle } from '../components/DriverToggle';
export const DriverEarnings: React.FC = () => {
  const earnings = {
    today: 425,
    week: 2850,
    month: 11400
  };
  const breakdown = [{
    label: 'Base Fares',
    amount: 9200
  }, {
    label: 'Border Fees',
    amount: 1800
  }, {
    label: 'Tips',
    amount: 400
  }];
  const stats = {
    trips: 142,
    hours: 98.5,
    rating: 4.9,
    acceptance: 95
  };
  return <div className="min-h-screen bg-background pb-16" data-id="element-258">
      <div className="p-6" data-id="element-259">
        <div className="flex items-center justify-between mb-6" data-id="element-260">
          <h1 className="text-xl font-semibold" data-id="element-261">Earnings</h1>
          <DriverToggle data-id="element-262" />
        </div>
        <div className="card mb-6" data-id="element-263">
          <div className="flex items-center mb-3" data-id="element-264">
            <DollarSignIcon size={20} className="text-primary mr-2" data-id="element-265" />
            <span className="text-sm text-white text-opacity-70" data-id="element-266">
              This Month
            </span>
          </div>
          <p className="text-4xl font-bold text-primary mb-4" data-id="element-267">
            RM {earnings.month.toLocaleString()}
          </p>
          <div className="grid grid-cols-2 gap-4 pt-4 border-t border-white border-opacity-10" data-id="element-268">
            <div data-id="element-269">
              <p className="text-sm text-white text-opacity-70" data-id="element-270">This Week</p>
              <p className="text-xl font-bold" data-id="element-271">RM {earnings.week}</p>
            </div>
            <div data-id="element-272">
              <p className="text-sm text-white text-opacity-70" data-id="element-273">Today</p>
              <p className="text-xl font-bold" data-id="element-274">RM {earnings.today}</p>
            </div>
          </div>
        </div>
        <div className="card mb-6" data-id="element-275">
          <h3 className="font-medium mb-4" data-id="element-276">Earnings Breakdown</h3>
          <div className="space-y-3" data-id="element-277">
            {breakdown.map((item, index) => <div key={index} className="flex items-center justify-between" data-id="element-278">
                <span className="text-white text-opacity-70" data-id="element-279">{item.label}</span>
                <span className="font-medium" data-id="element-280">RM {item.amount}</span>
              </div>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-281">
          <div className="card" data-id="element-282">
            <div className="flex items-center mb-2" data-id="element-283">
              <CarIcon size={16} className="text-primary mr-2" data-id="element-284" />
              <span className="text-sm text-white text-opacity-70" data-id="element-285">Trips</span>
            </div>
            <p className="text-2xl font-bold" data-id="element-286">{stats.trips}</p>
          </div>
          <div className="card" data-id="element-287">
            <div className="flex items-center mb-2" data-id="element-288">
              <ClockIcon size={16} className="text-primary mr-2" data-id="element-289" />
              <span className="text-sm text-white text-opacity-70" data-id="element-290">Hours</span>
            </div>
            <p className="text-2xl font-bold" data-id="element-291">{stats.hours}</p>
          </div>
          <div className="card" data-id="element-292">
            <div className="flex items-center mb-2" data-id="element-293">
              <TrendingUpIcon size={16} className="text-primary mr-2" data-id="element-294" />
              <span className="text-sm text-white text-opacity-70" data-id="element-295">Rating</span>
            </div>
            <p className="text-2xl font-bold" data-id="element-296">{stats.rating}</p>
          </div>
          <div className="card" data-id="element-297">
            <div className="flex items-center mb-2" data-id="element-298">
              <DollarSignIcon size={16} className="text-primary mr-2" data-id="element-299" />
              <span className="text-sm text-white text-opacity-70" data-id="element-300">Accept</span>
            </div>
            <p className="text-2xl font-bold" data-id="element-301">{stats.acceptance}%</p>
          </div>
        </div>
        <Button variant="secondary" data-id="element-302">Cash Out Earnings</Button>
      </div>
      <BottomNav data-id="element-303" />
    </div>;
};